import { isDeviceNative } from '../../utils/deviceDetection';
import { subscribe } from '@wh/message-bus';
import { MY_ACCOUNT_DROPDOWN_OPEN } from '../../topics';

export const myAccountNativeDeepLinksInit = (config) => {
  if (!config || !config.mapping || !config.enabled || !isDeviceNative()) {
    return;
  }

  const myAccountDropdownOpenHandler = ({ data }) => {
    if (!data || !data.path) {
      return;
    }
    const standaloneUrl = config.mapping[data.path];
    if (!standaloneUrl) {
      return;
    }
    window.location.href = `whsbkh://?action=openURLWithLogin&url=${encodeURIComponent(standaloneUrl)}`;
  };

  /* eslint-disable-next-line consistent-return */
  return subscribe({
    topic: MY_ACCOUNT_DROPDOWN_OPEN,
    callback: myAccountDropdownOpenHandler,
  });
};
